/* Reviews page: insert pasted widget embed code only when it nears the viewport.
   Scripts added through innerHTML don't run, so each one is recreated. */
(function () {
  function load(el) {
    if (el.dataset.loaded) return;
    el.dataset.loaded = 'true';
    var tpl = el.querySelector('template');
    if (!tpl) return;
    var frag = tpl.content.cloneNode(true);
    frag.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
      s.text = old.textContent;
      old.replaceWith(s);
    });
    el.appendChild(frag);
  }

  function init(root) {
    var els = (root || document).querySelectorAll('[data-primo-lazy-embed]:not([data-loaded])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          io.unobserve(e.target);
          load(e.target);
        }
      });
    }, { rootMargin: '400px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
